import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en.json";
import es from "./es.json";

const resources = {
  en: { translation: en },
  es: { translation: es },
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
} else {
  Object.entries(resources).forEach(([language, namespaces]) => {
    i18n.addResourceBundle(
      language,
      "translation",
      namespaces.translation,
      true,
      true
    );
  });
}

// i18n.changeLanguage = (lang) => i18n.changeLanguage(lang);

export default i18n;
